export const ROOT = `/loyalty`;
